export default class BracketGameTiebreaker {
  public statTotal: number | null = 0;
}
